import { Component, OnInit } from '@angular/core';
import { UtilitiesService } from '../../../common/shared/services/utilities.service';
import { AuthService } from '../../../common/shared/services/auth.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  constructor(
    private _authService: AuthService,
    private _utilitiesService: UtilitiesService) { }

  ngOnInit() {
    this._authService.checkUserLoggedIn();

    this._utilitiesService.removeInitAction(0);
  }

  profileActionsActive() {
    return this._utilitiesService.isActionActive('LoadContact') &&
           this._utilitiesService.isActionActive('LoadMemberships') &&
           this._utilitiesService.isActionActive('LoadEmployments');
  }
}
